<section class="scores-section">
  <header class="section-header">
    <h3>{{ title }}</h3>
  </header>

  <div
    #chartContainer
    class="chart-wrap chart-scroller"
  >
    <ngx-charts-bar-vertical-stacked
      [results]="groupedChart$ | async"
      [customColors]="ratingColors"
      [animations]="false"
      [legend]="false"
      [xAxis]="true"
      [yAxis]="true"
      [yAxisLabel]="peopleLabel"
      [showDataLabel]="true"
      [dataLabelFormatting]="dlFmt"
      [xAxisTickFormatting]="tickFmt"
      [barPadding]="20"
      [tooltipDisabled]="true"
    >
      <ng-template
        #tooltipTemplate
        let-model="model"
        ngx-charts-tooltip-template
      >
        <div class="custom-tooltip-content">
          <span>Nivel: {{ model.name }}</span>
          <br/>
          <span>Personas: {{ model.value }}</span>
        </div>
      </ng-template>
    </ngx-charts-bar-vertical-stacked>
  </div>

  @if (tableRows$ | async; as rows) {
    <table class="scores-table">
      <thead>
      <tr>
        <th class="col-name">{{ domainLabel }}</th>
        <th class="col-respond">{{ peopleLabel }}</th>
        <th class="col-badge">{{ levelLabel }}</th>
      </tr>
      </thead>

      <tbody>
        @for (r of rows; track trackByRow($index, r)) {
          <tr>
            <td class="name">
              <span class="idx-chip">{{ r.idx }}</span>
              {{ r.name }}
            </td>

            <td class="respond">{{ r.respondents | number : '1.0-0' }}</td>

            <td class="badge-col">
          <span
            class="badge"
            [style.background]="chipSolidBg(r.rating)"
            [style.color]="chipSolidFg(r.rating)"
          >
            {{ r.rating }}
          </span>
            </td>
          </tr>
        }
      </tbody>
    </table>
  }
  <div style="margin:20px"></div> <!-- Se agrega para exportacion a pdf. Se pueda renderizar bien -->
</section>
